import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import AuthContext from '../context/AuthContext';
import LoginForm from './LoginForm';
import GamesSection from './GamesSection';
import UpcomingSection from './UpcomingSection';
import BetaCountdown from './BetaCountdown';
import BetaLaunchPopup from './BetaLaunchPopup';
import LazyHeroImage from './common/LazyHeroImage';
import './homepage.css';
import heroMobile from '../assets/heros/hero-background-mobile.webp';
import heroTablet from '../assets/heros/hero-background-tablet.webp';
import heroDesktop from '../assets/heros/hero-background-desktop.webp';
import heroBlur from '../assets/heros/hero-background-blur.webp';
import versusLogo from '../assets/logos/versus-logo.svg';

function Homepage() {
  const { user } = useContext(AuthContext);
  
  // Telegram Bot URL
  const telegramBotUrl = 'https://t.me/Versusarenaentry_bot';

  return (
    <div className="homepage-container">
      {/* Beta Launch Popup */}
      <BetaLaunchPopup />
      
      <section className="homepage-hero-section">
        <LazyHeroImage
          srcMobile={heroMobile}
          srcTablet={heroTablet}
          srcDesktop={heroDesktop}
          blurSrc={heroBlur}
          alt="Versus Arena"
          className="homepage-hero-bg"
          fetchpriority="high"
        />
        <div className="homepage-hero-content">
          <h1>VersusArena</h1>
          <p>Your Skill, Your Earnings. Exclusive Access to the Future of Esports.</p>
          {user ? (
            <a 
              href={telegramBotUrl} 
              target="_blank" 
              rel="noopener noreferrer"
              className="homepage-cta-button"
            >
              PLAY NOW
            </a>
          ) : (
            <Link to="/register" className="homepage-cta-button">REGISTER NOW</Link>
          )}
        </div>
        {!user && <div className="homepage-login-form-desktop"><LoginForm /></div>}
      </section>

      <GamesSection />

      {/* Die CTA-Sektion, die sich dynamisch anpasst */}
      <section className="homepage-cta-section">
        {user ? (
          // Zustand, wenn der Benutzer angemeldet ist
          <div className="homepage-cta-content">
            <h2 className="homepage-cta-headline">ACCOUNT CENTER</h2>
            <p className="homepage-cta-subline">Manage your profile and settings</p>
            <Link 
              to="/account" 
              className="homepage-cta-button"
            >
              MANAGE ACCOUNT
            </Link>
          </div>
        ) : (
          // Zustand, wenn der Benutzer NICHT angemeldet ist
          <div className="homepage-cta-content">
            <h2 className="homepage-cta-headline">CREATE YOUR FREE ACCOUNT</h2>
            <p className="homepage-cta-subline">TO PLAY FAST, FUN AND FREE GAMES</p>
            <Link to="/register" className="homepage-cta-button">REGISTER NOW</Link>
          </div>
        )}
        
        {/* Das Logo bleibt immer in der Mitte, da es außerhalb der bedingten Logik liegt */}
        <div className="homepage-logo-container">
          <img src={versusLogo} alt="Versus Arena Logo" className="homepage-versus-logo" />
        </div>

        {/* Der rechte Teil, der immer gleich ist */}
        <div className="homepage-cta-content">
          <h2 className="homepage-cta-headline">VIEW GAME CATALOG</h2>
          <p className="homepage-cta-subline">BROWSE OUR FUN WEB AND MOBILE GAMES</p>
          <Link to="/games" className="homepage-cta-button">VIEW ALL GAMES</Link>
        </div>
      </section>

      {/* Beta Members Countdown */}
      <BetaCountdown />

      {/* Neue Upcoming Sektion mit Turnieren und Spielen */}
      <UpcomingSection />
    </div>
  );
}

export default Homepage;